import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  SubscriptionListPage,
  SubscriptionEditPage,
  SubscriptionOrderPage,
  SubscriptionCreatePage,
  SubscriptionAddOnsPage,
  SubscriptionAddOnsEditPage,
  SubscriptionInformationPage,
  SubscriptionAddOnsCreatePage,
  SubscriptionAddOnsInformationView,
} from './imports';

export const subscriptionRoutes = [
  {
    path: 'subscriptions',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.CREATE}
          >
            <SubscriptionCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/orders',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionOrderPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.UPDATE}
          >
            <SubscriptionEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/addons',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionAddOnsPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/addons/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.CREATE}
          >
            <SubscriptionAddOnsCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/addons/:addon/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.UPDATE}
          >
            <SubscriptionAddOnsEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/addons/:addonId/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <SubscriptionAddOnsInformationView />
          </PermissionGuard>
        ),
      },
    ],
  },
];
